var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', [_vm._v("LINE 主控台")]), _c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'RichMenu'
      }
    }
  }, [_vm._v("圖文選單")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(_vm._s(_vm.richMenu.title))])], 1)], 1)])]), _c('b-overlay', {
    attrs: {
      "show": _vm.isFetching
    }
  }, [_c('b-card', [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v(_vm._s("\u5DF2\u7D81\u5B9A".concat(_vm.richMenu.title, "\u7684\u6703\u54E1")))]), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('div', [_c('StaffAddCustomer', {
    ref: "staffAddCustomer",
    attrs: {
      "add-button-text": "綁定會員"
    },
    on: {
      "bind": _vm.linkCustomer
    }
  })], 1)]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.customers,
      "fields": _vm.fields
    },
    scopedSlots: _vm._u([{
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex align-items-center justify-content-center"
        }, [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1)], 1)];
      }
    }, {
      key: "cell(name)",
      fn: function fn(data) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.id
              }
            }
          }
        }, [_vm._v(_vm._s(_vm._f("hiddenString")(data.item.name, 20)))])];
      }
    }, {
      key: "cell(action)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "d-flex justify-content-center"
        }, [_c('b-button', {
          attrs: {
            "variant": "inverse-danger",
            "size": "sm"
          },
          on: {
            "click": function click($event) {
              return _vm.unlinkCustomer(data.item);
            }
          }
        }, [_vm._v(" 解除綁定 ")])], 1)];
      }
    }])
  })], 1)]), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.totalRows,
      "per-page": _vm.perPage,
      "align": "center"
    },
    on: {
      "change": _vm.fetchCustomers
    },
    model: {
      value: _vm.currentPage,
      callback: function callback($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }